module.exports = __webpack_public_path__ + "img/night-middle-bg_in.3be879bb.png";